
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.33 3.165h-1.651v-.767a.398.398 0 10-.796 0v.763H7.434v-.763a.398.398 0 10-.795 0v.763H4.99A1.99 1.99 0 003 5.15v10.862A1.99 1.99 0 004.989 18h10.34c1.098 0 1.988-.89 1.989-1.988V5.154a1.99 1.99 0 00-1.989-1.989zm-10.341.796h1.65v.763a.398.398 0 00.795 0v-.763h5.445v.763a.398.398 0 10.796 0v-.763h1.654a1.197 1.197 0 011.193 1.193v.978H3.795v-.978c.001-.659.535-1.193 1.194-1.193zm10.34 13.248H4.99a1.197 1.197 0 01-1.194-1.194V6.928h12.727v9.087a1.197 1.197 0 01-1.193 1.194z","fill":"#58697D","stroke":"#58697D","stroke-width":".5"}}),_c('path',{attrs:{"stroke":"#58697D","stroke-width":"1.5","stroke-linecap":"round","d":"M6.75 10.25h.5M9.75 10.25h.5M12.75 10.25h.5M6.75 13.25h.5M9.75 13.25h.5M12.75 13.25h.5"}})])
          )
        }
      }
    